// 开发环境配置
export default {
  // API基础URL
  baseURL: 'http://localhost:9681/',
  
  // 环境标识
  env: 'development',
  
  // 应用标题
  title: '继教管理系统（开发）',
  
  // 请求超时（毫秒）
  timeout: 30000,  // 30秒
  
  // 是否启用日志
  enableLog: true,
}

